import LanguageDropdown from "components/Language/LanguageDropdown"
import React, { Component } from "react"
import { Link } from "react-router-dom"
import { Menu, Modal } from "semantic-ui-react"
import { Row, Col, Form, FormField, FormInput, Button } from "elemental-react16"
import { withRouter } from "react-router"
import queryString from "qs"
import "pages/Login.css"
import settingStore from "stores/settingStore"
import shop from "shop/shop"

import WordPressContainer from "WordPressContainer"
import config from "config"

@withRouter
export default class LoginPage extends Component {
  constructor() {
    super()
    this.state = {
      user    : "",
      password: ""
    }
    shop.whoami()
  }

  handleLogin = ( e ) => {
    const currentMode = settingStore.get("orderMode")
    const { history } = this.props
    const query = queryString.parse( this.props.location.search.substr( 1 ) )
    const { referrer } = query
    shop.login( { ...this.state } )
      .catch( ( err ) => {
        console.error( err )
        shop.toast( translate("Fehler bei der Anmeldung"), "error" )
        return false
      } )
      .then( session => {
        if ( !session ) return

        shop.loadCategories()
        shop.cart.hydrate()
        shop.toast( `${translate("Willkommen")} ${session.value.title ? session.value.title : ""}` )
        let redirectTo = referrer || shop.locationAfterLogin
        const orderMode = settingStore.get( "orderMode" )
        const handId    = session.handId;

        if (handId && handId != '') {
          redirectTo = "/login/accounts/"
        } else if ( !orderMode ) redirectTo = shop.locationAfterLogin || "/home/"
        
        console.log( "AFTER LOGIN", redirectTo , shop.locationAfterLogin, currentMode)
        console.log(session);
        if ( redirectTo ) {
          history.push( redirectTo )
        } else {
          history.push( "/home" )
        }
      } )

    e.preventDefault()
  }

  handleUserChange = ( event ) => {
    this.setState( {
      user: event.target.value
    } )
  }

  handlePasswordChange = ( event ) => {
    this.setState( {
      password: event.target.value
    } )
  }

  render() {
    const query = queryString.parse( this.props.location.search.substr( 1 ) )
    return (
      <div className="LoginPage pb6">
        <div className=" container">
          <div className="white absolute top-0 right-2 pt2">
            <LanguageDropdown/>
          </div>

          <section>
            <Row>
              <Col className="text-center"
                   style={{ marginTop: "60px" }}>
                <Link to="/home/">
                  <img
                    src={shop.config.logo}
                    alt=""/>
                </Link>
              </Col>
            </Row>
          </section>

          <Row>
            <Col sm="4/12"> </Col>
            <Col sm="4/12">
              <div className="mw6"
                   style={{ marginTop: "60px" }}>
                <Form onSubmit={this.handleLogin}>
                  <FormField label={translate("Benutzer")}
                             htmlFor="basic-form-input-email">
                    <FormInput value={this.state.user}
                               onChange={this.handleUserChange}
                               type="text"
                               placeholder="Benutzer-ID"
                               name="basic-form-input-id"/>
                  </FormField>
                  <FormField label={translate("Passwort")}
                             htmlFor="basic-form-input-password">
                    <FormInput value={this.state.password}
                               onChange={this.handlePasswordChange}
                               type="password"
                               placeholder="Passwort"
                               name="basic-form-input-password"/>
                  </FormField>
                  {/*<FormField>*/}
                  {/*<Checkbox label="Login speichern" />*/}
                  {/*</FormField>*/}
                  <div className="tc pt3">
                    <Button submit
                            primary>{translate("Anmelden")}</Button>
                    <Link className="db mt3"
                          to="/reset_password">{translate("Passwort vergessen")}?</Link>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
          <hr/>

          <div className="tc pb5">
            <div className="black-50">{translate( "No account yet?" )}<a href="&#x6D;&#x61;&#x69;&#x6C;&#x74;&#x6F;&#x3A;&#x73;&#x65;&#x72;&#x76;&#x69;&#x63;&#x65;&#x40;arnoldsports.de">{translate( "customerservice")}</a>.</div>
            <Link to="/customer_registration">{translate( "register new account" )}</Link> <br/>
            {config.customer_enabling &&
            <Link to="/customer_enabling">{translate( "access with offline account" )}</Link>}
          </div>

          {config.b2cLink && <div>
            <hr/>
            <div className="tc">
              <a href={config.b2cLink}>{translate( "B2C Shop" )}</a>
            </div>
          </div>}
        </div>


        <div className="bg-silver fixed bottom-0 left-0 right-0">
          <Menu fluid
                secondary
                size="small">
            <Modal closeIcon={true}
                   trigger={<Menu.Item position="right">{translate( "Data Policy" )}</Menu.Item>}>
              <Modal.Content>
                <WordPressContainer postType="page"
                                    slug="datenschutz"/>
              </Modal.Content>
            </Modal>
            <Modal closeIcon={true}
                   trigger={<Menu.Item>AGB</Menu.Item>}>
              <Modal.Content>
                <WordPressContainer postType="page"
                                    slug="agb"/>
              </Modal.Content>
            </Modal>
            <Modal closeIcon={true}
                   trigger={<Menu.Item>{translate( "imprint" )}</Menu.Item>}>
              <Modal.Content>
                <WordPressContainer postType="page"
                                    slug="impressum"/>
              </Modal.Content>
            </Modal>
          </Menu>

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/theme/arnoldsports/pages/LoginPage.js